(function () {
var $6e2adab23bbff3d3$exports = {};
(function() {
    const task = getTaskID();
    if (task) {
        console.log(`Jira taskId: ${task}`);
        console.log(`URL: https://pixrig.atlassian.net/browse/${task}`);
        console.log("Hash commit: ", "901e99617fee3ec7c61dc78ad5c43bf12e938fce");
    }
    function getTaskID() {
        const commitMessage = undefined;
        if (commitMessage) {
            const taskID = commitMessage.match(/EN-\d+/);
            if (taskID) return taskID[0];
        }
        return null;
    }
})();

})();
//# sourceMappingURL=a-shoot.f032f3b7.js.map
